import React from 'react';

import { useMutation, useQuery } from '@apollo/client';
import { SET_SUBSCRIPTION_STATUS_MUTATION } from 'Queries/Mutations';
import { SUBSCRIPTION_STATUS_QUERY } from 'Queries/Queries';
import PropTypes from 'prop-types';

import 'components/MessageBox/MessageBox.scss';
import { OuterBox } from 'components/OuterBox/OuterBox';
import { Separator } from 'components/Separator/Separator';
import { SubTitle } from 'components/SubTitle/SubTitle';
import { SubscribeBoxSwitch } from 'components/SubscribeBox/SubscribeBoxSwitch';

import { TENANT_ID } from 'global/constants';

import { getPrivacyPath } from 'utils/UrlUtil';
import { getTenantId } from 'utils/tenantUtil';

import './SubscribeBox.scss';

export const SubscribeBox = ({ isCIAM }) => {
  const { data, loading, error } = useQuery(SUBSCRIPTION_STATUS_QUERY, {
    skip: isCIAM,
  });

  const [setSubscriptionStatus] = useMutation(SET_SUBSCRIPTION_STATUS_MUTATION, {
    refetchQueries: () => [{ query: SUBSCRIPTION_STATUS_QUERY, partialRefetch: true }],
    awaitRefetchQueries: true,
  });

  const getContent = () => {
    if (isCIAM)
      return (
        <div className="message-box subscribe-box">
          Passen Sie Ihre Einstellungen über die Seite <a href={getPrivacyPath()}>Datenschutz</a>{' '}
          an.
        </div>
      );
    return (
      <SubscribeBoxSwitch
        setSubscriptionStatus={setSubscriptionStatus}
        loading={loading}
        error={error}
        data={data}
      />
    );
  };
  return (
    <div className="message-box subscribe-box">
      <OuterBox className="message-box__outer-box">
        <SubTitle text="Auf dem Laufenden bleiben" notFramed />
        <Separator color={getTenantId() === TENANT_ID.AVA ? 'homepage' : 'secondary'} />
        <div>
          Möchten Sie per E-Mail über neue Nachrichten und Veranstaltungen informiert werden?
        </div>
        <br />
        {getContent()}
      </OuterBox>
    </div>
  );
};

SubscribeBox.propTypes = {
  isCIAM: PropTypes.bool,
};

SubscribeBox.defaultProps = {
  isCIAM: false,
};
